// All money is integer cents. Rounding is Math.round (half up for the positive amounts we bill).

export function toCents(eur: number): number {
  return Math.round(eur * 100);
}

export function lineTotalCents(quantity: number, unitPriceCents: number): number {
  return Math.round(quantity * unitPriceCents);
}

export function hoursAmountCents(minutes: number, rateCents: number): number {
  return Math.round((minutes * rateCents) / 60);
}

export function percentOfCents(totalCents: number, percent: number): number {
  return Math.round((totalCents * percent) / 100);
}

/** German grouping without Intl: de-AT groups with a narrow space, the documents use dots. */
function groupDe(intPart: string): string {
  return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

/** Fixed two decimals, German separators, no sign. */
function fixed2(abs: number): string {
  const [i, d] = abs.toFixed(2).split(".");
  return `${groupDe(i!)},${d}`;
}

function amount(cents: number): string {
  return fixed2(Math.abs(cents) / 100);
}

/** „2.144,30 EUR“. Negative amounts use an ASCII hyphen: the PDF standard fonts have no U+2212. */
export function eurPdf(cents: number): string {
  return `${cents < 0 ? "-" : ""}${amount(cents)} EUR`;
}

/** „2.144,30 €“, negative with the minus sign U+2212. */
export function eurUi(cents: number): string {
  return `${cents < 0 ? "−" : ""}${amount(cents)} €`;
}

/** „03.11.2026“ from YYYY-MM-DD. */
export function deDate(iso: string): string {
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}.${m}.${y}`;
}

/** „1,00 Stk“. */
export function qtyPdf(q: number, unit: string): string {
  return `${q < 0 ? "-" : ""}${fixed2(Math.abs(q))} ${unit}`;
}

/** Hours from minutes, at most two decimals, trailing zeros dropped: „5“, „1,5“, „0,75“. */
export function hoursDe(minutes: number): string {
  const s = (Math.round((minutes / 60) * 100) / 100).toFixed(2).replace(/\.?0+$/, "");
  return s.replace(".", ",");
}
